import { createSelector } from 'reselect'

import { getParsedDateUntilToday, getRangeFromDateFilter } from 'utils/dateUtils'

const selectData = (state) => state.dashboard.threatProtection.list.data
const selectLoader = (state) => state.dashboard.threatProtection.list.loader
const selectError = (state) => state.dashboard.threatProtection.list.error

const selectListType = (state) => state.dashboard.threatProtection.list.listType

const selectSearch = (state) => state.dashboard.threatProtection.list.search

const selectDateFilter = (state) => state.dashboard.threatProtection.list.dateFilter
const selectDateFilterCustomRange = (state) => state.dashboard.threatProtection.list.feDateRange
const selectDateRange = createSelector(
  selectDateFilter,
  selectDateFilterCustomRange,
  (dateFilter, dateFilterCustomRange) => dateFilterCustomRange || getRangeFromDateFilter(dateFilter)
)
const selectParsedDate = (state) => {
  const currentDateFilter = selectDateFilter(state)
  return getParsedDateUntilToday(currentDateFilter)
}

const selectPage = (state) => state.dashboard.threatProtection.list.page
const selectBannerTypeFilter = (state) => state.dashboard.threatProtection.list.bannerTypeFilter
const selectIncidentTypeFilter = (state) => state.dashboard.threatProtection.list.incidentTypeFilter
const selectTagsFilter = (state) => state.dashboard.threatProtection.list.tagsFilter
const selectDepartmentFilter = (state) => state.dashboard.threatProtection.list.departmentFilter
const selectResolvedByFilter = (state) => state.dashboard.threatProtection.list.resolvedByFilter
const selectReportedByFilter = (state) => state.dashboard.threatProtection.list.reportedByFilter
const selectResolutionTypeFilter = (state) =>
  state.dashboard.threatProtection.list.resolutionTypeFilter
const selectThreatTypeFilter = (state) => state.dashboard.threatProtection.list.threatTypeFilter

export {
  selectData,
  selectLoader,
  selectError,
  selectListType,
  selectSearch,
  selectDateFilter,
  selectParsedDate,
  selectPage,
  selectBannerTypeFilter,
  selectIncidentTypeFilter,
  selectTagsFilter,
  selectDepartmentFilter,
  selectResolvedByFilter,
  selectReportedByFilter,
  selectResolutionTypeFilter,
  selectThreatTypeFilter,
  selectDateRange,
}
